import { Observable } from 'rxjs';
import { MedServiceGroup, DataSourceResponse } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable({ providedIn: 'root' })
export class MedServicesGroupService extends ApiService {
  endPoint = '/api/medservicegroups';
  create(model: MedServiceGroup) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: MedServiceGroup) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<MedServiceGroup> {
    return this.http.get<MedServiceGroup>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<MedServiceGroup>> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }
}
